import React, { Component } from 'react';
import {BASE} from '../api/api'
import cachios from 'cachios'
import ReactHtmlParser from 'react-html-parser';

class ArchiveDesc extends Component {
    constructor(props) {
        super(props);
        this.state={
            desc:''
      }
    }

  componentWillMount(){
        cachios.get(BASE+'jsonapi/block_content/basic?include=field_image', {
            ttl: 300 /* seconds */,
        })
            .then((data) => {
                console.log(data.data.data,'desc')

                this.setState({
                    desc:data.data.data,
                    descimg:data.data.included[0]
                })
            })
            .catch((err) => {
                console.log('not found')
            })
    }
    
    
    render() {

        return (
            <div className="listing">
                <div className="basicpage text-justify">
                    {/* {this.state.descimg?
                        <div className="row">
                            <div className="region region-content">
                                <div className="listings">
                                    <div className='archive_topimg'>
                                        <img  src={BASE+this.state.descimg.attributes.uri.url} alt='dum'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    :''} */}

                    {/* Description */}

                    {this.state.desc?
                            ReactHtmlParser(this.state.desc ? this.state.desc[0].attributes.body.processed : '')
                    :''}
                    
                    
                </div>
                            
            </div>   
        )
    
    
}

}


export default ArchiveDesc;
